import styled from 'App/styled';

export const Wrapper = styled.div`
  display: inline-block;
  width: 30%;
  padding-top: 10px;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${(props) => props.theme.footerLinks};
  padding-left: 15px;
  padding-right: 15px;

  h2 {
    ${({ theme }) => theme.typography.titleXSmall};
    margin: 10px 0 10px;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

export const Row = styled.tr`
  border-top: 1px solid #ebebeb;
  padding: 10px 0;
  align-items: center;
  display: flex;
  justify-content: space-between;
  line-height: 17px;

  .titleColumn {
    width: 78%;
    display: inline-block;
    vertical-align: middle;

    span {
      float: right;
      padding-left: 5px;
    }
    .heading {
      font-weight: 600;

      &.name {
        float: left;
      }
    }
    a {
      ${({ theme }) => theme.typography.bodyMedium};
      color: ${(props) => props.theme.footerLinks};
      display: inline-block;
      text-decoration: none;
    }
  }

  .priceColumn {
    font-weight: 600;
    display: inline-block;
    vertical-align: baseline;
    color: ${(props) => props.theme.footerLinks};
  }

  &.last-update {
    padding-top: 7px;
    padding-bottom: 7px;
    display: block;
    padding-left: 5px;
    font-weight: 600;
  }
`;
